const pagination = {
    pageSize: 100
};

export default pagination;
